import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import SignatureCanvas from "react-signature-canvas";
import logo from "../logo-400.jpg";
import PrivateApi from "../services/PrivateApiService";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import SplashPage from "./SplashPage";
import ErrorPage from "./ErrorPage";
import { useRef, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";

const VollmachtSignPage = () => {

    const API = new PrivateApi();
    const { token } = useParams();
    const [view, setView] = useState("done");
    let signature = useRef(null);
    const [signImage, setSignImage] = useState("");

    const [hide, setHide] = useState({
        deleteBtn: true,
        signPad: false,
        doneBtn: true,
        image: true,
        sendBtn: true,
        sending: true,
    })
    
    const {data, error, isLoading} = useQuery(["GET_VOLLMACHT_DATA", token], () => API.get_Vollmacht_data(token), {staleTime: Infinity});

    const signatureChange = () => {
        setHide(prev => ({...prev, 
            deleteBtn: false,
            doneBtn: false
        }));
    }

    const deleteSignature = (e) => {
        e.preventDefault();
        signature.clear();
        setHide(prev => ({...prev, 
            deleteBtn: true,
            doneBtn: true
        }));
    }

    const signatureDone = () => {
        let sign = signature.toDataURL('png').split(",")[1];
        setSignImage(sign);
        setHide(prev => ({...prev, 
            deleteBtn: true,
            signPad: true,
            doneBtn: true,
            image: false,
            sendBtn: false,
        }))
    }

    const sendData = () => {
        setHide(prev => ({...prev,
            sendBtn: true,
            sending: false
        }));
        API.post_Vollmacht_save({vollmacht: signImage})
            .then(res => {
                const base64 = res.data.file.split(',').pop(); // Extract the base64 part of the file data
        
                // construct a Blob from the base64 string
                const binaryString = window.atob(base64);
                const len = binaryString.length;
                const bytes = new Uint8Array(len);

                for (let i = 0; i < len; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }

                // Create a blob from the bytes
                const blob = new Blob([bytes], { type: "application/pdf" });

                // Create a download link and trigger it
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = res.data.file_name;
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);

                setView("done");
            })
            .catch(err => {
                console.error(err);
            })
            .finally(() => {
                setHide(prev => ({...prev, sending: true}))
            })
    }

    if (isLoading) return <SplashPage />
    if (error) return <ErrorPage />
    return (
        <Container>
            <Row className="mt-5 align-items-center">
                <Col xs="12">
                    <h5 className="text-energo">Vertretungsvollmacht/Auftrag</h5>
                    <p className="text-muted">Wir benötigen eine Unterschrift von Ihnen</p>
                </Col>

            </Row>
            <Row className="mt-5">
                <Col xs="12">
                    <Card className="shadow-lg" style={{ borderRadius: 15, border: "3px solid #a2c13f" }}>
                        {view === "default" ? 
                            <Card.Body>
                                <Row className="mt-4 align-items-center mb-4">
                                    <Col xs="12" md="9" xl="10">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td style={{width: 150}}><b>{data.data.user_data.company_type === "person"? "Name": "Firmenname"}</b></td>
                                                    <td>{data.data.user_data.name}</td>
                                                </tr>
                                                {data.data.user_data.company_type === "person" &&
                                                    <tr>
                                                        <td><b>Geburtsdatum</b></td>
                                                        <td>{new Date(data.data.user_data.x_birthdate).toLocaleDateString("DE-de")}</td>
                                                    </tr>
                                                }
                                                {data.data.user_data.company_type === "company" &&
                                                    <tr>
                                                        <td><b>UID</b></td>
                                                        <td>{data.data.user_data.vat}</td>
                                                    </tr>
                                                }
                                                <tr>
                                                    <td><b>Adresse</b></td>
                                                    <td>{data.data.user_data.address}</td>
                                                </tr>
                                        </tbody>
                                        </table>
                                    </Col>
                                    <Col xs="12" md="3" xl="2">
                                        <img src={logo} width={120} />
                                    </Col>
                                </Row>
                                <p><small dangerouslySetInnerHTML={{__html: data.data.vollmacht_text}}></small></p>
                                <Row className="mt-5 mb-5 align-items-center">
                                    <Col xs="12" md="12" xl="4" className="text-center">
                                        <div style={{borderBottom: "1px solid black"}}>
                                            <b>{new Date().toLocaleDateString('DE-de')}</b>
                                        </div>
                                        Datum
                                    </Col>
                                    <Col xs="12" md="12" xl="3"></Col>
                                    <Col xs="12" md="12" xl="5" className="text-center">
                                        <a 
                                            href="#" 
                                            hidden={hide.deleteBtn}
                                            onClick={e => deleteSignature(e)}
                                            className="link-energo text-danger">
                                                Löschen
                                            </a>
                                        <div>
                                            <div hidden={hide.showImage} style={{borderBottom: "1px solid black"}}>
                                                <img width={300} src={"data:image/png;base64," +signImage} alt="" />
                                            </div>
                                            <div hidden={hide.signPad}>
                                                <SignatureCanvas
                                                    ref={(ref) => { signature = ref }}
                                                    penColor="black"
                                                    backgroundColor="rgba(0,0,0,0)"
                                                    canvasProps={{ className: 'sigCanvas', }}
                                                    onEnd={signatureChange}
                                                />
                                            </div>
                                        </div>
                                        {hide.doneBtn ? 
                                            "Unterschrift Kunde/Kundin":
                                            <Button variant="energo" style={{width: 150}} onClick={() => signatureDone()}>Fertig</Button>
                                        }
                                    </Col>
                                </Row>
                                <Row className="mt 3">
                                    <Col xs="12" className="text-center">
                                        <Button onClick={() => sendData()} hidden={hide.sendBtn} variant="energo" className="btn-lg">Absenden</Button>
                                        <Spinner animation="border" className="text-energo" hidden={hide.sending} />
                                    </Col>
                                </Row>
                            </Card.Body> :
                            <Card.Body>
                                <Row>
                                    <Col className="text-center">
                                        <FaCheckCircle className="text-energo" size={40}/>
                                        <h3 className="text-energo mt-3">Fertig!</h3>
                                        <p className="mt-3">Vielen Dank! Ihre Vollmacht wurde erfolgreich erstellt.</p>
                                    </Col>
                                </Row>
                            </Card.Body>
                        }
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}
export default VollmachtSignPage;